import { render, staticRenderFns } from "./IdeaItem.vue?vue&type=template&id=ed929264&scoped=true&"
import script from "./IdeaItem.vue?vue&type=script&lang=js&"
export * from "./IdeaItem.vue?vue&type=script&lang=js&"
import style0 from "./IdeaItem.vue?vue&type=style&index=0&id=ed929264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed929264",
  null
  
)

export default component.exports